export const contexts = {
    DEFAULT: 'default',
    FARMI_APP_APPRO: 'farmi-app-appro',
    SERVER_SIDE: 'server-side',
};
//# sourceMappingURL=index.js.map